import { render, staticRenderFns } from "./DataSplitDisplay.vue?vue&type=template&id=c7fd9e3e&scoped=true&"
import script from "./DataSplitDisplay.vue?vue&type=script&lang=js&"
export * from "./DataSplitDisplay.vue?vue&type=script&lang=js&"
import style0 from "./DataSplitDisplay.vue?vue&type=style&index=0&id=c7fd9e3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fd9e3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VIcon,VRow,VSelect,VSheet})
